module.exports = __webpack_public_path__ + "images/emoji/cop.d8eb3d270a8a612cd73b.png";